import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve(parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/wishlists`, parameters)
    },

    create(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/wishlists/create`,
            parameters
        )
    },

    delete(parameters) {
        return requester.put(
            `${BACKEND_API_V1_URL}/wishlists/delete`,
            parameters
        )
    },

    count(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/wishlists/count`,
            parameters
        )
    },
}
